import { render, staticRenderFns } from "./FullReductionPromotion.vue?vue&type=template&id=3742e13e&scoped=true&"
import script from "./FullReductionPromotion.vue?vue&type=script&lang=js&"
export * from "./FullReductionPromotion.vue?vue&type=script&lang=js&"
import style0 from "./FullReductionPromotion.vue?vue&type=style&index=0&id=3742e13e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3742e13e",
  null
  
)

export default component.exports